module.exports = __webpack_public_path__ + "static/media/Methodology.02d6a3cc.png";